<div class="h-full" fxLayout="column">
  <div class="p-6" fxFlex="none">
    <div vexContainer>
      <div fxLayout="row" fxLayoutAlign="space-between center">
        <div
          class="bg-card rounded-full border px-4"
          fxFlex="400px"
          fxFlex.lt-md="auto"
          fxHide.xs
          fxLayout="row"
          fxLayoutAlign="start center"
        >
          <ic-icon [icIcon]="icSearch" size="20px"></ic-icon>
          <input class="px-4 py-3 border-0 outline-none w-full bg-transparent" placeholder="Recherche..." #search />
          <button *ngIf="search.value" matSuffix mat-icon-button aria-label="EFFACER" (click)="clearTextFilter()">
            <ic-icon [icIcon]="icClose" size="20px"></ic-icon>
          </button>
        </div>

        <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">
          <!-- Bouton basculer vers vue archivés (uniquement pour établissements support) -->
          <button
            *ngIf="establishment?.establishmentType === 'SUPPORT_FUNCTION'"
            (click)="toggleArchivedView()"
            [color]="showArchived ? 'accent' : 'basic'"
            fxFlex="none"
            mat-raised-button
            type="button"
            matTooltip="{{ showArchived ? 'Voir les contacts actifs' : 'Voir les contacts archivés' }}"
          >
            <ic-icon
              [icon]="showArchived ? icVisibility : icVisibilityOff"
              class="ltr:mr-2 rtl:ml-2 ltr:-ml-1 rtl:-mr-1"
              inline="true"
              size="20px"
            ></ic-icon>
            <span>{{ showArchived ? 'Contacts actifs' : 'Contacts archivés' }}</span>
          </button>

          <!-- Bouton ajouter contact (masqué en vue archivés) -->
          <button
            *ngIf="!showArchived"
            [permissionBlock]="[ENUM_PERMISSION.UPDATE_ESTABLISHMENT]"
            (click)="addContact()"
            class="ltr:ml-4 rtl:mr-4"
            color="primary"
            fxFlex="none"
            fxHide.xs
            mat-raised-button
            type="button"
          >
            <ic-icon
              [icon]="icPersonAdd"
              class="ltr:mr-2 rtl:ml-2 ltr:-ml-1 rtl:-mr-1"
              inline="true"
              size="20px"
            ></ic-icon>
            <span>Ajouter un contact</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="(filteredContacts$ | async)?.length > 0" @stagger class="overflow-y-auto" fxFlex="auto">
    <div
      class="p-gutter"
      vexContainer
      gdColumns="1fr 1fr 1fr 1fr"
      gdColumns.lt-md="1fr 1fr"
      gdColumns.xs="1fr"
      gdGap="24px"
    >
      <vex-contacts-card
        (openContact)="openContact($event)"
        (onEdit)="editContact(contact)"
        (onDelete)="deleteContact(contact)"
        (onArchive)="archiveContact(contact)"
        (onUnarchive)="unarchiveContact(contact)"
        *ngFor="let contact of filteredContacts$ | async"
        @fadeInUp
        [contact]="contact"
        [canUpdate]="!showArchived && (contact.isEstablishmentContact || isInternalContact(contact))"
        [canDelete]="!showArchived && !isInternalContact(contact)"
        [canArchive]="canArchiveContact(contact)"
        [canUnarchive]="canUnarchiveContact(contact)"
        [updatePermission]="[ENUM_PERMISSION.UPDATE_ESTABLISHMENT]"
        [deletePermission]="[ENUM_PERMISSION.UPDATE_ESTABLISHMENT]"
        [callPermission]="[ENUM_PERMISSION.READ_ESTABLISHMENT]"
        [sendPermission]="[ENUM_PERMISSION.READ_ESTABLISHMENT]"
        [linkPermission]="[ENUM_PERMISSION.READ_INTERNAL_CONTACT]"
        [ngClass]="{
          'archived-contact': contact.isArchivedForEstablishment || showArchived,
          'readonly-contact': showArchived
        }"
      >
        <div class="body-2 text-secondary">
          <span>{{ contact?.role?.name }}</span>
          <span
            *ngIf="contact.isArchivedForEstablishment || showArchived"
            class="ml-2 text-xs bg-gray-200 text-gray-700 px-2 py-1 rounded"
          >
            Archivé
          </span>
        </div>
      </vex-contacts-card>
    </div>
  </div>

  <div
    *ngIf="(filteredContacts$ | async)?.length === 0"
    @scaleFadeIn
    fxFlex="auto"
    fxLayout="column"
    fxLayoutAlign="center center"
  >
    <img class="m-12 h-64" src="assets/img/illustrations/idea.svg" />
    <h2 class="headline m-0 text-center">Il n'y a pas de contact pour cet établissement</h2>
  </div>
</div>
